<div class="dialog-content-container">
  <div class="dialog-header mb-2">
    <img src="assets/images/shield.svg" alt="Seguridad" class="shield-icon" />
    <h3 class="dialog-title">Autenticación por dos factores</h3>
  </div>
  <div class="dialog-content">
    <p class="dialog-content-text mb-4">
      Su cuenta ya tiene autenticación por dos factores configurada.
    </p>
    <button
      pButton
      type="button"
      [disabled]="submitting"
      label="Desactivar autenticación con dos factores"
      class="p-button w-full text-sm"
      (click)="onNext()"
    ></button>
  </div>
</div>
